export const CORRESPONDENT_STATES = {
  registered: { id: 1, description: 'Registrado' },
  enabled: { id: 2, description: 'Activo' },
  temporarilyClosed: { id: 3, description: 'Cierre temporal' },
  definitelyClosed: { id: 4, description: 'Cierre definitivo' },
} as const;

export const SUBSIDIARY_STATES = {
  registered: { id: 1, value: 'Registrado' },
  enabled: { id: 2, value: 'Activo' },
  corespondentTemporallyClosed: { id: 3, value: 'Cierre Temporal Corresponsal' },
  temporarilyClosed: { id: 4, value: 'Cierre Temporal Sucursal' },
  definitelyClosed: { id: 5, value: 'Cierre Definitivo' },
} as const;

export const TRANSFER_STATES = {
  inProgress: 'En curso',
  completed: 'Completada',
  canceled: 'Cancelada',
  reverted: 'Revertida',
} as const;

export const TRANSFER_TYPES = {
  cashin: 'Abono de dinero',
  cashout: 'Retiro de dinero',
} as const;

export const NOTIFICATION_STATES = {
  success: 'Exitoso',
  failed: 'Fallido',
} as const;

export const getNotificationStatusLabel = (status?: string | null): string => {
  if (!status) return '';
  const key = status.toLowerCase() as keyof typeof NOTIFICATION_STATES;
  return NOTIFICATION_STATES[key] ?? status;
};

export const CASHIN_STATES = {
  validating: 'validating',
  completed: 'completed',
  registeringBasics: 'registeringBasic',
  active: 'ACTIVE',
  onlycredit: 'ONLYCREDIT',
} as const;

export const CASHOUT_STATES = {
  validating: 'validating',
  success: 'success',
  onlydebit: 'ONLYDEBIT',
  active: 'ACTIVE',
} as const;

export const PAGINATION_SIZE = 5;
export const CURRENT_PAGE = 0;

export const constants = {
  initialDate: '2021-01-01',
  countryPhoneCode: '591',
  openStatus: 1,
  closeStatus: 2,
  tenant: 'tenant',
  correspondentTypesEnable: ['Corporativo', 'Unipersonal'],
  token: 'TOKEN',
  redirectKey: 'redirect',
  defaultRolesAdminCorrespondent: ['Cajero Corresponsal Corporativo', 'Consultas Corresponsal', 'Supervisor sucursal'],
  defaultRolesAdminBank: ['Consultas Banco', 'Analista Corresponsalia'],
  roles: {
    adminBank: 'Administrador de Usuarios Banco',
    adminCorrespondent: 'Administrador Corresponsal',
  },

  subsidiaries: [
    { id: 1, value: 'Registrado', color: '#1976D2' },
    { id: 2, value: 'Activo', color: '#83CF02' },
    { id: 3, value: 'Cierre Temporal Corresponsal', color: '#FFA445' },
    { id: 4, value: 'Cierre Temporal Sucursal', color: '#FFA445' },
    { id: 5, value: 'Cierre Definitivo', color: '#DC004E' },
  ],
  contactTypes: {
    administrator: 'administrador',
    financial: 'financiero',
  },
  comissionTypes: {
    cashin: 'CASHIN',
    cashout: 'CASHOUT',
  },
  expiditionCI: [
    { id: 1, exp: 'SC' },
    { id: 2, exp: 'LP' },
    { id: 3, exp: 'CB' },
    { id: 4, exp: 'TJ' },
    { id: 5, exp: 'CH' },
    { id: 6, exp: 'PA' },
    { id: 7, exp: 'BE' },
    { id: 8, exp: 'OR' },
    { id: 9, exp: 'PO' },
  ],
  request: {
    max_requests_count: 1,
    interval_ms: 100,
  },
  correspondent: {
    ROLE_CORRESPONDENT: 'Consultas Corresponsal',
  },
  notesFilter: ['Todos', 'Notas', 'Sin notas'],
} as const;
